import { BlogItem } from '@/entities/BlogItem/ui/BlogItem'
import './ui/BlogItem.scss'
export default BlogItem
